import { render, staticRenderFns } from "./IntegrationsModal.vue?vue&type=template&id=d45d95f8&"
import script from "./IntegrationsModal.vue?vue&type=script&lang=js&"
export * from "./IntegrationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports